import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorised-error-page',
    templateUrl: './unauthorised-error-page.component.html',
    styleUrls: ['./unauthorised-error-page.component.sass'],
    standalone: false
})
export class UnauthorisedErrorPageComponent { }